import { useTranslation } from "react-i18next";
import PaymentMethodEn from "@/assets/Img/payment-method-mock-en.png";
import PaymentMethodEs from "@/assets/Img/payment-method-mock-es.png";
import LanguageEn from "@/assets/Img/choose-language-mock-en.png";
import LanguageEs from "@/assets/Img/choose-language-mock-es.png";
import PaymentEnLogo from "@/assets/Img/select-payment-method-en.png";
import PaymentEsLogo from "@/assets/Img/select-payment-method-es.png";
import { Card } from "@/components/Card";

import "./styles.module.css";

export const StickyCards = () => {
  const [t, i18n] = useTranslation("global");
  const lang = i18n.language;

  return (
    <div className="flex flex-col gap-8 w-full pt-10 lg:pt-20 lg:flex-row max-w-screen-sm lg:max-w-none">
      <div className="sticky top-20 w-full pb-64 md:pb-96 md:h-full lg:pb-10 lg:top-[100px] max-w-screen-lg">
        <h2
          className="font-semibold text-2xl md:text-3xl lg:text-6xl 2xl:text-7xl lg:mt-10"
          dangerouslySetInnerHTML={{ __html: t("Home.Section2.Title") }}
        />
        <p
          className="text-lg lg:text-2xl 2xl:text-3xl lg:my-4"
          dangerouslySetInnerHTML={{ __html: t("Home.Section2.Subtitle") }}
        />
      </div>
      <div className="flex flex-col pb-20 items-end -mt-64 md:-mt-96 lg:mt-0 w-full">
        <Card
          className="!bg-primary-500 text-white min-w-80 max-w-[40rem] p-10 md:py-12 !rounded-large h-[28rem] sm:h-[32rem] md:h-[38rem] w-full overflow-hidden sticky top-[230px] sm:top-[200px] lg:top-[140px]"
          noPadding
          rest
        >
          <div className="flex flex-col h-full gap-2">
            <p className="text-center text-2xl sm:text-3xl leading-tight font-[500] md:text-4xl">
              {t("Cards.Card1.Title")}
            </p>
            <p
              className="text-center text-base sm:text-lg md:text-xl"
              dangerouslySetInnerHTML={{
                __html: t("Cards.Card1.Paragraph"),
              }}
            />
            <p
              className="text-center text-xs md:text-sm italic"
              dangerouslySetInnerHTML={{
                __html: t("Cards.Card1.Disclaimer"),
              }}
            />
            <div className="h-full w-full flex justify-center translate-y-4">
              {lang === "en" ? (
                <img
                  className="h-[38rem] md:h-[43rem] w-auto -my-14 md:-my-10 object-contain object-top"
                  src={PaymentMethodEn}
                />
              ) : (
                <img
                  className="h-[38rem] md:h-[43rem] w-auto -my-14 md:-my-12 object-contain object-top"
                  src={PaymentMethodEs}
                />
              )}
            </div>
          </div>
        </Card>

        <Card
          className="!bg-primary-dark text-white min-w-80 max-w-[40rem] p-10 md:py-12 !rounded-large h-[28rem] sm:h-[32rem] md:h-[38rem] w-full overflow-hidden sticky top-[230px] sm:top-[200px] lg:top-[140px] translate-y-[40px] md:translate-y-[50px]"
          noPadding
          rest
        >
          <div className="flex flex-col gap-2 h-full">
            <p className="text-center text-2xl sm:text-3xl leading-tight font-[500] md:text-4xl">
              {t("Cards.Card2.Title")}
            </p>
            <p className="text-center text-base sm:text-lg md:text-xl leading-tight mt-2">
              {t("Cards.Card2.Paragraph")}
            </p>

            <div className="h-full w-full flex justify-center translate-y-4">
              {lang === "en" ? (
                <img
                  className="h-[38rem] md:h-[43rem] w-auto -my-14 md:-my-14 object-contain object-top"
                  src={LanguageEn}
                />
              ) : (
                <img
                  className="h-[38rem] md:h-[43rem] w-auto -my-14 md:-my-14 object-contain object-top"
                  src={LanguageEs}
                />
              )}
            </div>
          </div>
        </Card>

        <Card
          className="!bg-secondary text-white min-w-80 max-w-[40rem] p-10 md:py-12 !rounded-large h-[28rem] sm:h-[32rem] md:h-[38rem] w-full overflow-hidden sticky top-[230px] sm:top-[200px] lg:top-[140px] translate-y-[80px] md:translate-y-[100px]"
          noPadding
          rest
        >
          <div className="flex flex-col h-full gap-2">
            <p className="text-center text-2xl sm:text-3xl leading-tight font-[500] md:text-4xl">
              {t("Cards.Card3.Title")}
            </p>

            <p
              className="text-center text-base sm:text-lg md:text-xl leading-tight mt-2"
              dangerouslySetInnerHTML={{
                __html: t("Cards.Card3.Paragraph"),
              }}
            />

            <div className="h-full w-full flex justify-center translate-y-4">
              {lang === "en" ? (
                <img
                  className="h-[38rem] md:h-[43rem] w-auto -my-6 md:-my-12 object-contain object-top"
                  src={PaymentEnLogo}
                />
              ) : (
                <img
                  className="h-[38rem] md:h-[43rem] w-auto -my-10 md:-my-14 object-contain object-top"
                  src={PaymentEsLogo}
                />
              )}
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};
